module.exports = __webpack_public_path__ + "static/media/afl-ver-cen-black.a5907ac6.svg";